import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

interface PortalPageContentProps {
  children: ReactNode;
  className?: string;
}

/** Customer portal content width — narrower and more focused than internal admin pages. */
export function PortalPageContent({ children, className }: PortalPageContentProps) {
  return <div className={cn('mx-auto w-full min-w-0 max-w-6xl', className)}>{children}</div>;
}
